import { render, staticRenderFns } from "./LicenseInformationModuleField.vue?vue&type=template&id=f073f94a&scoped=true"
import script from "./LicenseInformationModuleField.vue?vue&type=script&lang=ts"
export * from "./LicenseInformationModuleField.vue?vue&type=script&lang=ts"
import style0 from "./LicenseInformationModuleField.vue?vue&type=style&index=0&id=f073f94a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f073f94a",
  null
  
)

export default component.exports